<template lang="pug">
div.user-icon-changer-photo.f.fh
  v-icon(v-if="!isUploading"
    size="22px"
    @click="addPhoto" dark) mdi-autorenew
  v-progress-circular(v-else size="18" width="3" indeterminate color="white")
</template>

<style scoped lang="scss">
@import "@/scss/_variables.scss";

.user-icon-changer-photo {
  transform: rotate(45deg);
}
</style>

<script>
import { storage } from '@/components/utils/firebase'
import { Camera, CameraResultType, CameraSource } from '@capacitor/camera'

export default {
  data () {
    return {
      takenPhoto: null,
      isUploading: false
    }
  },
  props: {
    uid: {
      type: String,
      required: true
    }
  },
  methods: {
    async addPhoto () {
      this.takenPhoto = await Camera.getPhoto({
        quality: 90,
        allowEditing: false,
        resultType: CameraResultType.DataUrl,
        source: CameraSource.Prompt,
        webUseInput: true,
        saveToGallery: true
      })

      this.isUploading = true

      const base64 = this.takenPhoto.dataUrl
      this.resizeImage(base64, this.uploadImg)
    },
    getUniqueStr (myStrong) {
      let strong = 1000
      if (myStrong) strong = myStrong
      return new Date().getTime().toString(16)  + Math.floor(strong * Math.random()).toString(16)
    },
    resizeImage (base64image, callback) {
      let image = new Image()
      image.crossOrigin = 'Anonymous'
      image.onload = async () => {
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')

        const THUMBNAIL_WIDTH = 300
        const THUMBNAIL_HEIGHT = 300

        let width, height, ratio
        if (image.width > image.height) {
          ratio = image.height / image.width
          width = THUMBNAIL_WIDTH
          height = THUMBNAIL_WIDTH * ratio
        } else {
          ratio = image.width / image.height
          width = THUMBNAIL_HEIGHT * ratio
          height = THUMBNAIL_HEIGHT
        }
        canvas.setAttribute('width', width)
        canvas.setAttribute('height', height)

        ctx.clearRect(0, 0, width, height)
        ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height)
        
        const trimmedImage = await this.trimImage(canvas.toDataURL())

        callback(trimmedImage)
      }
      image.src = base64image
    },
    async trimImage (base64) {
      const TRIM_SIZE = 300
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')

      canvas.width = canvas.height = TRIM_SIZE
      canvas.id = 'canvas-photo'

      const img = await this.loadImage(base64, 'Anonymous')

      let width, height, xOffset, yOffset
      if (img.width > img.height) {
        height = TRIM_SIZE
        width = img.width * (TRIM_SIZE / img.height)
        xOffset = -(width - TRIM_SIZE) / 2
        yOffset = 0
      } else {
        width = TRIM_SIZE
        height = img.height * (TRIM_SIZE / img.width)
        yOffset = -(height - TRIM_SIZE) / 2
        xOffset = 0
      }
      ctx.drawImage(img, xOffset, yOffset, width, height)
      return canvas.toDataURL()
    },
    async uploadImg (base64) {
      const fileId = this.getUniqueStr()
      let storageRef = storage.ref()
      const imgRef = storageRef.child(`USER/${this.uid}/ICON/${fileId}.${this.takenPhoto.format}`)
      const imgURL = await imgRef.putString(base64.split(',')[1], 'base64').then(async (snapshot) => {
        const url = await snapshot.ref.getDownloadURL().then(downloadURL => downloadURL)
        return url
      })
      // console.log('updateImg', imgURL)
      this.$emit('updateImg', imgURL)
      this.isUploading = false
    }
  }
}
</script>